// eslint-disable-next-line
define(function () {
  function noop() {}
  return {
    legacyRouter: {
      replaceToRoute: noop,
      navigateToRoute: noop,
      getRouteUrl: noop,
    },
    replaceToRoute: noop,
    navigateToRoute: noop,
    getRouteUrl: noop,
  };
});
